export default __webpack_public_path__ + "static/media/test.01e9901b.jpeg";